module.exports = __webpack_public_path__ + "img/ede007958a32102353c31284b3f4d6bc.837084df.png";